import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  { id: "79b2e8e2-b252-4a8e-96cc-4c6ca120a9d9", content: "The DnT = 50 dB and R’ = 50 dB.", options: {} },
  { id: "07575766-e08d-4154-8d32-3c42f206ac1b", content: "The DnT = 52 dB and R’ is higher.", options: {} },
  { id: "20491a13-342f-4b86-8f32-f0ffabdf1a13", content: "The DnT = 50 and R’ is lower.", options: {} },
  {
    id: "0f0a2c89-ec3e-49b0-86a2-27cd46def13d",
    content: "The DnT = 50 dBA and R’ can not be determined.",
    options: {},
  },
];

export const task: Task = {
  id: "078b91d9-cdab-4fd4-8762-9206def6021c",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: false,
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["0f0a2c89-ec3e-49b0-86a2-27cd46def13d"],
};
